import * as z from "zod/v4";

export const leaderboardRowSchema = z.object({
  rank: z.number(),
  name: z.string(),
  totalItemsProcessed: z.number(),
  totalItemsPicked: z.number(),
});

export type LeaderboardRow = z.infer<typeof leaderboardRowSchema>;

export const get3plLeaderboard = {
  name: "get3plLeaderboard" as const,
  input: z.object({
    startDate: z.date(),
    endDate: z.date(),
    returnsCenterId: z.string().optional(),
  }),
  output: z.object({ rows: z.array(leaderboardRowSchema) }),
};
